/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Geosuggest from "react-geosuggest";
import * as uuid from "react-native-uuid";
import { Row, Col } from "react-bootstrap";

class LocationComponent extends Component {
  handleSuggestSelect = suggest => {
    if (!suggest) {
      return;
    }
    const customLocation = {
      address: {},
      GPS: {},
      type: { code: "JOB" }
    };
    const location = this.props.location;
    if (!location.externalId) {
      customLocation.externalId = uuid.v4();
    }
    customLocation.GPS.Lat = suggest.location.lat;
    customLocation.GPS.Lng = suggest.location.lng;
    suggest.gmaps.address_components.forEach(addressComponent => {
      if (addressComponent.types.includes("street_number")) {
        customLocation.address.number = addressComponent.long_name;
        return;
      }

      if (addressComponent.types.includes("route")) {
        customLocation.address.street = addressComponent.long_name;
        return;
      }

      if (addressComponent.types.includes("locality")) {
        customLocation.address.suburb = addressComponent.long_name;
        return;
      }

      if (addressComponent.types.includes("administrative_area_level_1")) {
        customLocation.address.state = addressComponent.short_name;
        return;
      }

      if (addressComponent.types.includes("postal_code")) {
        customLocation.address.postcode = addressComponent.long_name;
        return;
      }

      if (addressComponent.types.includes("country")) {
        customLocation.address.country = addressComponent.long_name;
      }
    });

    const updatedLocation = { ...location, ...customLocation };
    this.props.handleLocationChange(updatedLocation);
  };

  render() {
    let locationString = "";
    const address = this.props.location.address;
    if (address) {
      const { number, street, suburb, country } = address;
      locationString = `${number || ""} ${street || ""} ${suburb ||
        ""} ${country || ""}`;
    }

    return (
      <div className="location-component">
        <Row>
          <Col sm={3} className="cust-label">
            <label className="location-label" htmlFor="location">
              Address
            </label>
          </Col>

          <Col sm={9}>
            <Geosuggest
              country={["au", "nz"]}
              onSuggestSelect={this.handleSuggestSelect}
              inputClassName="form-control"
              name="location"
              initialValue={locationString}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
LocationComponent.propTypes = {
  location: PropTypes.object.isRequired,
  handleLocationChange: PropTypes.func.isRequired
};

export default LocationComponent;



// WEBPACK FOOTER //
// ./src/forms/fields/LocationComponent.js